export default function calculateProgress(maximumProgress, progress) {
  const percentage = Math.round((progress / maximumProgress) * 100);
  return percentage;
}
